import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const MySoftiesView = styled.section`
	display: block;
`;

export const MySoftiesHeadingWrap = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	gap: 16px;
	margin-bottom: 18px;

	h2 {
		margin-bottom: 0;
		font-size: clamp(1.45rem, 2.8vw, 2rem);

		span {
			color: #fff;
			background: ${THEME.gradientHighlight};
			-webkit-background-clip: text;
			background-clip: text;
			-webkit-text-fill-color: transparent;
			filter: drop-shadow(0 0 12px rgba(255, 77, 242, 0.42));
		}
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		margin-bottom: 14px;

		h2 {
			font-size: clamp(1.12rem, 5vw, 1.35rem);
			line-height: 1.12;
		}
	}
`;
